import { render, staticRenderFns } from "./CardProjectUpcoming.vue?vue&type=template&id=7025bc8c"
import script from "./CardProjectUpcoming.vue?vue&type=script&lang=js"
export * from "./CardProjectUpcoming.vue?vue&type=script&lang=js"
import style0 from "./CardProjectUpcoming.vue?vue&type=style&index=0&id=7025bc8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports